import { render, staticRenderFns } from "./CompArticleCategories.vue?vue&type=template&id=87ee0a9e"
import script from "./CompArticleCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticleCategories.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports